import React, { useEffect, useRef, useMemo } from 'react';
import ContentLayout from '../../layout/contentLayout';
import { useLocation } from 'react-router-dom';
import { handelCampainToken } from '../../constant/utils';
import { LocalStorage } from '../../custom_hooks/localStorageKeys';
import { dashboardAction } from '../../store/slices/dashboard';
import { useDispatch } from 'react-redux';
import { config } from '../../constant';

const Campaigns = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const env = import.meta.env.VITE_APP_ENV;
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event.data?.type === 'CVM_IFRAME') {
        console.log('Received from iframe:', event.data);

        if (event?.data?.message?.data) {
          // Dispatch asynchronously so it doesn’t trigger a re-render immediately
          setTimeout(() => {
            dispatch(dashboardAction.setCallNotification(true));
          }, 0);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [dispatch]);

  const sourceUrl = useMemo(() => {
    const encryptedToken = handelCampainToken({
      key: location?.state?.key ?? '',
      value: location?.state?.value ?? '',
      cvmanalytics: location?.state?.data ?? '',
    });

   
    return `${config().CAMPAIGN_URL}/cvmcampaign?cvm_data=${encryptedToken}`;
    // return `https://2a20ab9f5cb6.ngrok-free.app/cvmcampaign?cvm_data=${encryptedToken}`;
  }, [location?.state]);

  const postData = useMemo(() => localStorage.getItem('CVM_ANALYTICS'), []);

  return (
    <iframe
      id="smsCampaignFrame"
      ref={iframeRef}
      src={sourceUrl}
      style={{ width: '100%', height: '100%', border: 'none' }}
      allow="microphone *"
      name={JSON.stringify(postData)}
    />
  );
};

export default React.memo(Campaigns);
